import { trpc } from './trpc';

/**
 * Store-scoped Apple Pay status for the store integration panel: whether the
 * store's domains have active Apple Pay and via which path (own BYOK, an
 * admin-managed shared certificate, or the legacy platform domain pool).
 */
export function useStoreApplePayStatus(storeId: string, opts?: { enabled?: boolean }) {
  return trpc.applePayRegistrations.storeStatus.useQuery(
    { storeId },
    { enabled: (opts?.enabled ?? true) && !!storeId, staleTime: 30 * 1000 },
  );
}
